import NotificationList from './NotificationList';
import { BellIcon, SearchIcon } from '../../assets/Icon';
import { OverlayTrigger, Button, Popover, Overlay } from 'react-bootstrap';
import styles from './style.module.scss';
import Input from '../ui/Input';
import { useContext, useRef, useState } from 'react';
import NotificationContext from '../../contexts/NotificationContext';

const Notifications = () => {
  const [showNotifications, setShowNotifications] = useState(false);
  const notificationTarget = useRef(null);
  const { hasNewNotifications, setHasNewNotification } =
    useContext(NotificationContext);

  const handleClick = () => {
    setShowNotifications(!showNotifications);
    setHasNewNotification(false);
  };
  return (
    <>
      <Button
        ref={notificationTarget}
        variant="plain"
        className="position-relative"
        onClick={handleClick}
      >
        {hasNewNotifications && <span className={`${styles.bubble}`}></span>}
        <BellIcon />
      </Button>
      <Overlay
        show={showNotifications}
        target={notificationTarget.current}
        placement="bottom-end"
        rootClose
        onHide={() => setShowNotifications(false)}
      >
        {props => (
          <Popover
            id="notification-popover"
            className={styles.notificationPopover}
            {...props}
          >
            <Popover.Body
              className={styles.notificationBody}
              id="scrollableDiv-notifications"
            >
              <div className={styles.notificationHeader}>
                <h5 className={styles.title}>Notifications</h5>
              </div>
              <NotificationList />
            </Popover.Body>
          </Popover>
        )}
      </Overlay>
    </>
  );
};

export default Notifications;
